<div class="notifications">
    <div class="notifications-inner">
        <div class="notifications-title d-flex justify-content-between align-items-center">
            <div class="txt-title">{{ 'IRONSIDE.notification-list.ALL_NOTIFICATIONS' | translate }}</div>
            <div class="icon-title">
                <a
                    *ngIf="hasUnread()"
                    (click)="markAllAsRead()"
                    style="margin-right: 12px"
                    href="javascript:void(0)"
                    ><img src="src-ironside/assets/icons/icon-mail.svg" alt=""
                /></a>
                <a href="javascript:void(0)" (click)="close()">
                    <img src="src-ironside/assets/icons/icon-close.svg" alt=""
                /></a>
            </div>
        </div>
        <div class="notifications-body">
            <div
                *ngFor="let item of notifications"
                class="notifications-item"
                [class.active]="item.isUnread"
                (click)="read(item)"
            >
                <p>{{ item.message }}</p>
                <span>{{ 'IRONSIDE.notification-list.ON' | translate }} {{ item.createdAt | date : 'dd/MM/yyyy HH:mm' }}</span>
            </div>
            
            <!-- skeleton start -->
            <ng-container *ngIf="!notifications">
                <div class="notifications-item" *ngFor="let _ of [1,2,3]">
                    <p-skeleton styleClass="w-50 mb-2"></p-skeleton>
                    <p-skeleton styleClass="mb-2"></p-skeleton>
                </div>
            </ng-container>
            <ng-container *ngIf="notifications?.length === 0">
                <div class="notifications-item">{{ 'IRONSIDE.notification-list.NO_ITEMS' | translate }}</div>
            </ng-container>
            <!-- skeleton end -->
        </div>
    </div>
</div>
